import React from 'react';
import NewHeader from './sections/NewHeader';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-cream">
      <NewHeader />
      <main className="pt-20 md:pt-24">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;

